import { useState } from "react";
import toast from "react-hot-toast";

const useClipboard = () => {
  const [copied, setCopied] = useState(false);

  const copyText = (text) => {
    if (!navigator.clipboard) {
      toast.error("Clipboard not supported");
      return;
    }

    navigator.clipboard
      .writeText(text)
      .then(() => {
        setCopied(true);
        toast.success(`Copied`);
        setTimeout(() => setCopied(false), 2000);
      })

      .catch((err) => {
        toast.error("Failed to copy text");
        console.error("Failed to copy text: ", err);
      });
  };

  return { copied, copyText };
};

export default useClipboard;
